import { render, staticRenderFns } from "./languageModule.vue?vue&type=template&id=e185fa64&"
import script from "./languageModule.vue?vue&type=script&lang=js&"
export * from "./languageModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports